import request from '@/utils/request';

export async function queryRoles() {
  return request('/roles');
}

export async function queryUserRoles(userId) {
  return request(`/users/${userId}/roles`);
}

export async function queryPortals() {
  return request('/portals');
}

export async function queryRolePortal(urlIndex) {
  return request(`/roles/${urlIndex}/portals`);
}

export async function changeUserRoles(userId, params, method = 'POST') {
  return request(`/users/${userId}/roles/new`, {
    method,
    body: params,
  });
}

export async function changeRolePortal(urlIndex, params) {
  return request(`/roles/${urlIndex}/portals`, {
    method: 'PUT',
    body: {
      ...params,
      method: 'put',
    },
  });
}

export async function changeRole(params) {
  return request('/roles', {
    method: 'PUT',
    body: {
      ...params,
      method: 'put',
    },
  });
}

export async function addRole(params) {
  return request('/roles', {
    method: 'POST',
    body: {
      ...params,
      method: 'post',
    },
  });
}

export async function deleteRole(urlIndex) {
  return request(`/roles/${urlIndex}`, {
    method: 'DELETE',
  });
}

// 查询到角色的门户之后,加载门户下的所有目录;目录有递归
export async function qryDirListByPartyId(partyId, portalId) {
  return request(`/portals/${portalId}/party/${partyId}/dirs`);
}

// 查询跟目录下的子元素
export async function qryDirListByDirId(dirId) {
  return request(`dirs/${dirId}/dirs`);
}
